import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { TOKEN_KEY } from '@/core/storage'
import { MOCK_USER } from '@/core/seed'
import { USE_API } from '@/core/config'
import { loginApi, fetchMeApi } from '@/core/api/auth'
import { resolveUserRoleBadge } from '@/modules/auth/roleBadge'

export const useAuthStore = defineStore('auth', () => {
  const user = ref(null)
  const token = ref(localStorage.getItem(TOKEN_KEY) || '')
  const loaded = ref(false)

  const isAuthenticated = computed(() => Boolean(token.value && user.value))
  const userRoleBadge = computed(() => resolveUserRoleBadge(user.value))

  function mapUser(data) {
    const isSuper = Boolean(data.isSuper) || data.role === 'SUPER'
    const canManageAccounts =
      Boolean(data.canManageAccounts) || isSuper
    return {
      id: data.id ?? null,
      username: data.username,
      displayName: data.displayName,
      role: data.role || (isSuper ? 'SUPER' : 'USER'),
      canManageAccounts,
      isSuper
    }
  }

  async function login(username, password) {
    if (USE_API) {
      try {
        const res = await loginApi(username, password)
        token.value = res.token
        localStorage.setItem(TOKEN_KEY, token.value)
        user.value = mapUser(res.user)
        loaded.value = true
        return { code: 0, message: 'ok' }
      } catch (e) {
        return { code: 1, message: e.message || '登录失败' }
      }
    }
    if (username === MOCK_USER.username && password === MOCK_USER.password) {
      token.value = 'mock-jwt-token'
      localStorage.setItem(TOKEN_KEY, token.value)
      user.value = mapUser(MOCK_USER)
      loaded.value = true
      return { code: 0, message: 'ok' }
    }
    return { code: 1, message: '账号或密码错误' }
  }

  function logout() {
    token.value = ''
    user.value = null
    loaded.value = false
    localStorage.removeItem(TOKEN_KEY)
  }

  async function fetchMe() {
    if (!token.value) {
      loaded.value = true
      return
    }
    if (USE_API) {
      try {
        const me = await fetchMeApi()
        user.value = mapUser(me)
      } catch {
        token.value = ''
        user.value = null
        localStorage.removeItem(TOKEN_KEY)
      }
      loaded.value = true
      return
    }
    user.value = mapUser(MOCK_USER)
    loaded.value = true
  }

  return {
    user,
    token,
    loaded,
    isAuthenticated,
    userRoleBadge,
    login,
    logout,
    fetchMe
  }
})
